import { CheckboxFilter, type Option } from '@lifebit-ai/lds'
import React from 'react'

import { useGetImportRequestLabelsFilter } from 'services/import-requests/hooks/useGetImportRequestLabelsFilter'

interface ImportRequestLabelsFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestLabelsFilter = ({ onApply, onReset }: ImportRequestLabelsFilterProps) => {
  const labelsQuery = useGetImportRequestLabelsFilter()

  const options: Option[] =
    labelsQuery.data?.data.map(label => ({
      label: label.name,
      value: label._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Labels"
      loading={labelsQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search labels"
    />
  )
}
